export const GOLFER_FITTING_CTAS = [
  'Analyzing your profile...',
  'Optimizing carry distance...',
  'Maximizing control...',
  'Improving consistency...',
  'Checking shaft fit...',
  'Comparing launch data...',
  'Matching club gapping...',
  'Researching current equipment...',
  'Reviewing price-to-value fit...',
  'Finalizing your recommendation...',
  'Balancing forgiveness and precision...',
  'Checking swing-speed compatibility...',
  'Matching loft and lie to your game...',
  'Evaluating turf interaction...',
  'Reviewing spin and trajectory...',
  'Assessing performance trade-offs...',
  'Searching the web for updated information...',
  'Comparing data points...',
  'Finding the best prices...',
  'Calculating launch conditions...',
  'Reviewing historical data...',
  'Researching new equipment releases...',
  'Considering expert feedback...'
] as const;

export const GOLFER_BAGGING_CTAS = [
  'Reviewing driver-to-wood gaps...',
  'Checking iron spacing and redundancy...',
  'Finding wedge loft inconsistencies...',
  'Evaluating scoring-club distance gaps...',
  'Comparing hybrid and long-iron options...',
  'Reviewing putter and ball fit...',
  'Finalizing bag optimization recommendations...',
  'Assessing club head speed and launch...',
  'Checking yardage consistency through the set...',
  'Reviewing forgiveness versus precision trade-offs...',
  'Evaluating long-game scoring opportunities...',
  'Comparing club options for better gapping...',
  'Reviewing turf interaction and contact quality...',
  'Checking setup balance from driver to wedge...',
  'Analyzing performance gaps in the scoring clubs...',
  'Prioritizing the most urgent fixes first...',
  'Validating the best replacement options...',
  'Mapping the most efficient bag rebuild steps...',
  'Cross-checking loft, lie, and distance data...',
  'Preparing the final recommendation summary...'
] as const;

export const GOLFER_PRODUCT_RESULTS_CTAS = [
  'Searching for clubs that match your fit...',
  'Finding product matches for your profile...',
  'Comparing shafts and lofts to your results...',
  'Checking performance specs against your swing...',
  'Reviewing product options for your bag gaps...',
  'Matching clubs to your distance in your profile...',
  'Finding the best fit for your scoring clubs...',
  'Checking forgiveness against your needs...',
  'Comparing the best brands for your setup...',
  'Scanning for better options in your price range...',
  'Looking for products that improve consistency...',
  'Matching equipment to your speed, angle, etc...',
  'Comparing top recommendations side by side...',
  'Reviewing strong product matches for your game...',
  'Weighing trade-offs between options...',
  'Finalizing the best options for your fit profile...'
] as const;

export const GOLFER_FITTING_CTA_INTERVAL_MS = 1800;
export const GOLFER_BAGGING_CTA_INTERVAL_MS = 3600;
export const GOLFER_PRODUCT_RESULTS_CTA_INTERVAL_MS = 2700;
